import { RESTOCK_TYPE } from '../../constants';

export const checkRestockTypeCondition = ({ restockType, product }) => {

	// All products
	if (restockType === RESTOCK_TYPE.ALL_PRODUCTS) {
		return true;
	}

	// Fresh food only
	if (restockType === RESTOCK_TYPE.FRESH_FOOD_ONLY && product?.isFreshFood) {
		return true;
	}

	// Exclude fresh food
	if (restockType === RESTOCK_TYPE.EXCLUDE_FRESH_FOOD && !product?.isFreshFood) {
		return true;
	}

	return false;
};
